import TitledSection from './TitledSection.view';

export default TitledSection;
